import type { ApexOptions } from 'apexcharts';

/** Общие настройки зума и тулбара для линейных графиков внешнего мониторинга */
export const externalMonitoringLineChartInteractions: Pick<
  NonNullable<ApexOptions['chart']>,
  'zoom' | 'toolbar'
> = {
  zoom: {
    enabled: true,
    type: 'x',
    autoScaleYaxis: true,
    allowMouseWheelZoom: false,
  },
  toolbar: {
    show: true,
    tools: {
      download: false,
      selection: true,
      zoom: true,
      zoomin: true,
      zoomout: true,
      pan: true,
      reset: true,
    },
  },
};
